// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"SelectUserTable_headerContainer__1TvSP","space":"SelectUserTable_space__32x1W","input":"SelectUserTable_input__2nLaJ","table":"SelectUserTable_table__39gUK"};